import React from 'react';
import { useParams } from 'react-router-dom';
import { PAGE_COMMON_TEXT } from '../lang';
import { useGetNominationInformation } from '../../../Assessment/graphql';
import { Loading, Alert } from '../../../../components';
import { Evaluation, EVALUATION_SCENE } from '../../../Nomination/components';

export const ScholarshipEvaluation: React.FunctionComponent = () => {
  const { applicationId = '' } = useParams();

  const { scholarshipNomination, isUPAF, loading, error } =
    useGetNominationInformation({
      application: { _id: { eq: applicationId } },
    });

  if (error) {
    return (
      <Alert
        openAlert={true}
        setOpenAlert={() => {}}
        alertDetails={{
          alertContent: `Error Occurs.` + (error as Error)?.message,
          alertType: 'error',
        }}
      />
    );
  }

  return (
    <>
      {loading ? (
        <Loading />
      ) : isUPAF ? (
        <Evaluation
          scene={EVALUATION_SCENE.VIEW_ONLY}
          applicationId={applicationId}
          scholarshipNomination={scholarshipNomination}
          refetchEvaluation={() => {}}
        />
      ) : (
        <div className="px-2 pt-4">
          {PAGE_COMMON_TEXT.SIDEBAR_TEXT.SCHOLARSHIP_EVALUATION.HINT}
        </div>
      )}
    </>
  );
};
